
/*
 * .  . .  .  . .  .  . .  .  . .  .  . .  .  . .  .  . .  .  . .  .  . .  .  . .  .  . .  .  . .  .
 *    .       .       .       .       .       .       .       .       .       .       .       .
 *      . :SXt. .  :%X%. . ..%S%: . .    . .    .  .    .  .    .  .    .  .    .  .    .  .    .  . .
 *  .   .;8XSXt8 .S8@SX8@  888SS8t.    ..8  %t    .  .      .       .       .   ;X  X:      .
 *    . @%@:8;S8 t8%t8 X8.:88%8.X8X     ;8;:S; .       .  .   . ;;.   .  .    . t8.:X:.t..    .  . .  .
 *   .  8XXS tS8;X88S.SX8::8X; 8X8@ .  .:X;     . .  .   .      t@     .   .   .88    t;8   .   .
 *      8S88:@8@8888S X8888888.8X8@   . @ . . .  ...   .   .. . ;8  .    .   . .8S .  %8: .   .    . .
 *   . .8X88. ;8S%8;.  .8;:8%..8@8@   :S88.S@ ;t@::S S.  @;XttSS88;;;8;;   . %t:@8%:t X8; 8@% :; .
 *      8@@S  .  ...   .. .:. .8X8@ .   S;.:  X8    ;8X t8S     t8   .@;  .88; .8%. . @8.  :8 .8   . .
 *   . .8@@8;  .     .  .     .8X8@    .tX;  ;88.    X@ t8t     t8 .  88S t8@  :8S    @@%   t88.
 *      @@88:     .      .  . .8@8@  . .X .  :8: .  .@S t8@     S@.  . 88%8:.  .8S .  88:  X8%8S.  .  .
 *   .  8X88. .  .   . .   .  .8X8@     X : ..88t%;S@8X %8%  . .:8.     %88t  .:8S   .X8% S8S:X88:
 *     .8XXS    .   .         .8X8@ . ..88.    tXX SS%  :8t     @8. .  .888.   .@S .  tX: 88.. SS:  .
 *   .  8@88:.    .     . .  . 8X8@    .:. .    .: .  . ..  . .  .     S8%. .  .     .    ..       .  .
 *     .@@88:  .     .         8X8@    .     . .   .      .     .  .   SX    .   .      .      .
 *   .  8XX8;    .    .  .  . .8X8X .   . .      .   .  .    .       .88X. .      . . .    .  .  .  .
 *      ;. %  .    .       .  .;:;:.  .     .  .           .   . .  . :;      . .        .         .  .
 *   . . .  .   .   .  .             .   .    .   . . .  .               .  .      .  .    . .  .
 *        .       .      .  . .  .     .   .    .       .   . .  . .  .    .   .        .        .  .
 *   .  .    . .     .    .     .  .     .   .     .  .   .            .  .      . . .    .  . .     .
 *
 * Copyright FortyFix(c) 2026.
 * Title: InterventiAlima.ts;
 * Path: /Volumes/Dati/SbSW_SoftwareBySystem_Works/Fortyfix/GESFF_Gestionale_FF_Angular/src/environments/Modules/InterventiAlima.ts;
 * Description: ;
 * Author: giovannibattistadellaporta;
 * Created at: 03/04/26, 12:33;
 *
 *
 */

import { TaskService } from "src/app/task/_service/task.service";
import { EnvironmentModel } from "../BaseEnvironments/Model";
import { ActionButton, DynamicCrudService } from "src/app/shared/_services/dynamic-crud.service"
import { BottoneAggiuntivo, CampoAggiuntivo, CheckObject, Sezione } from "src/app/shared/models/campo-aggiuntivo";
import { NewsComponent } from "src/app/task/news/news.component";
import { ApiPathsService } from "src/app/api-paths.service";
import { ToastrService } from "ngx-toastr";
import {
    DateToString, Oggi, ScadutaConOrario, dateTimeStringToFormattedDateTime, isBetween, isBetweenString, isDateAfterToday,
    DateToDateTimeString
} from "src/environments/Utility/DateUtility";
import { forkJoin } from "rxjs";

export var InterventiAlimaEnv = () => {

    var env: any = {
        Modules: {

        },
        filtrife: [
            { id: "R", label: "Interventi", capacita: [], module: undefined, restRoute: '/rma/interventi/list' },
        ],
        TaskAddon: {
            hideDateFilter: true,
            sidebarFilter: undefined,
            Filter: [
                Object.assign(
                    CampoAggiuntivo.InputField(
                        "INIZIO",
                        "inizio",
                        "date",
                        "col-lg-6"
                    ),
                    {
                        OnChange: "DateFilterChange"
                    }
                ),

                Object.assign(
                    CampoAggiuntivo.InputField(
                        "FINE",
                        "fine",
                        "date",
                        "col-lg-6"
                    ),
                    {
                        OnChange: "DateFilterChange"
                    }
                ),
                //CampoAggiuntivo.InputField("CERCA PER DATA", 'periodo', 'checkbox', 'col-lg-1'),
                Object.assign(
                    CampoAggiuntivo.SingleDropdown(
                        "RESPONSABILE",
                        'tecnici',
                        "/anagrafica/persone/list",
                        'fullName',
                        {
                            responseHasData: true,
                            parameter: [
                                { nome: "page", value: 1 },
                                { nome: "size", value: 2000 }
                            ]
                        },
                        'col-lg-3',
                        () => true,
                        {
                            singleSelection: false,
                            singleOutput: false,
                            closeDropDownOnSelection: true,
                            idField: 'id',
                            textField: 'fullName',
                            allowSearchFilter: true,
                            searchPlaceholderText: "Cerca"
                        }
                    ),
                    {
                        hideif: {
                            hasRoles: ['OP']
                        }
                    }
                ),
                Object.assign(
                    CampoAggiuntivo.SingleDropdown(
                        "BENEFICIARIO",
                        'clienti',
                        '/anagrafica/clienti/list',
                        'fullName',
                        {
                            responseHasData: true,
                            parameter: [
                                { nome: "page", value: 1 },
                                { nome: "size", value: 2000 },
                                { nome: "ruolo", value: "C" }
                            ]
                        },
                        'col-lg-3',
                        () => true,
                        {
                            singleSelection: false,
                            singleOutput: false,
                            closeDropDownOnSelection: true,
                            idField: 'id',
                            textField: 'statoCivile',
                            allowSearchFilter: false,
                            searchPlaceholderText: "Cerca"
                        }
                    ),
                    {
                        hideif: {
                            func: (filtro: any) =>
                                filtro?.hideCliente !== true
                        }
                    }
                ),
                CampoAggiuntivo.SingleDropdown("CHIUSO", 'chiuso', [{ id: true, label: 'Chiuso' }, { id: false, label: 'Non Chiuso' }], 'label', {}, 'col-lg-3'),
                Object.assign(
                    CampoAggiuntivo.InputField(
                        "PROGRAMMAZIONE INTERVENTI",
                        "soloPadriRicorrenti",
                        "checkbox",
                        "col-lg-3"
                    ),
                    {

                        hideif: {
                            hasRoles: ['OP']
                        }

                    }
                ),
                CampoAggiuntivo.SingleDropdown("TIPO", 'tipo', '/settings/get', 'label', { parameter: [{ nome: 'id', value: 'tipo_intervento' }, { nome: 'type', value: 'tipo_intervento' }] }, 'col-lg-3'),
                CampoAggiuntivo.SingleDropdown(
                    "BENE",
                    'accessorio',
                    '/prodotti/list',
                    'prodotto',
                    {
                        responseHasData: true,
                        parameter: [
                            { nome: 'page', value: 1 },
                            { nome: 'size', value: 200 },
                            { nome: 'tipo', value: 69 }
                        ]
                    },
                    'col-lg-3',
                    () => true,
                    {
                        singleSelection: true,
                        closeDropDownOnSelection: true,
                        singleOutput: true,
                        idField: 'id',
                        textField: 'prodotto',
                        allowSearchFilter: true,
                        searchPlaceholderText: 'Cerca'
                    }
                ),
                CampoAggiuntivo.SingleDropdown("APPROVATO", 'approvazione', [{ id: true, label: 'Approvato' }, { id: false, label: 'Non Approvato' }], 'label', {}, 'col-lg-3'),
            ],
            isTuttiVisible: (ListComponent) => {
                const _permittedRoles: string[] = ['AZ', 'amministratore', 'RT', 'Amministrazione', 'SP', 'Commerciale', 'All', 'SC'];

                let visible = false;

                _permittedRoles.forEach(role => {
                    const Ra = ListComponent.AuthService?.currentUserValue?.ruoliAccessoObject?.find(
                        x => x.ruolo?.toUpperCase() == role.toUpperCase() || x.id == role
                    );

                    const R = ListComponent.AuthService?.currentUserValue?.ruoliObject?.find(
                        x =>
                            (typeof x.id == 'string' && x.id?.toUpperCase() == role.toUpperCase()) ||
                            x.id == role ||
                            x.ruolo?.toUpperCase() == role.toUpperCase()
                    );

                    visible = visible || Ra != undefined || R != undefined;
                });

                return visible;
            },
            DynamicFields: [InterventiAlima()]
        }
    };
    return env;
}
var InterventiAlima = () => {

    const formatDate = (date: Date): string => {
        const year = date.getFullYear();
        const month = String(date.getMonth() + 1).padStart(2, '0');
        const day = String(date.getDate()).padStart(2, '0');

        return `${year}-${month}-${day}`;
    };

    var task: {
        afterAddMap?: (task: any, service: TaskService) => any,
        type?: string,
        tipo?: string,
        addButton?: boolean,
        restRoute?: string,
        Label?: string,
        Azioni?: BottoneAggiuntivo[],
        campi?: CampoAggiuntivo[]
        sezioni?: Sezione[],
        managerLoggato?: CheckObject,
        hideif?: CheckObject,
        initObj?: { campo: string, tipo: string }[],
        map?: (x) => any,
        mapList?: (x: any[], filtro?: any) => any,
        TrStyle?: (item: any) => any,
        OnSaveMap?: (x: any, api: ApiPathsService, bup: any, component: DynamicCrudService) => any,
        CalendarMap?: (x) => { start: Date, end: Date, title: string, color: { primary: string, secondary: string }, type: string, id: string, task: any },
        onCloseGoTo?: (x: NewsComponent) => string,
        Headers?: CampoAggiuntivo[],
        externalValidation?: (item?, api?: ApiPathsService, toastr?: ToastrService) => boolean, // ritornare true se validazione passata
        AzioniTask?: BottoneAggiuntivo[],
        defaultFilter: any,
        AzioniLista?: any[],
        isTuttiVisible?: (ListComponent: any) => boolean,
        ConcatToList?: (api: ApiPathsService, currentTasks: any[], filtro: { inizio: string, fine: string, stati: string[] }, Concat: (x) => void, DynamicCrudService: DynamicCrudService) => void
    } = {
        ConcatToList: (api: ApiPathsService, currentTasks: any[], filtro: { inizio: string, fine: string, stati: string[] }, Concat: (x) => void, DynamicCrudService: DynamicCrudService) => {

            const user = JSON.parse(
                localStorage.getItem('currentUser') || '{}'
            );

            const isOperatore = user?.ruoliObject?.some(
                r => r.id === 'OP'
            );

            const filtroBackend = { ...filtro };

            delete filtroBackend['soloPadriRicorrenti'];

            const filter = Object.assign(
                {},
                filtroBackend,
                {
                    tipo: 'R',
                    effettivo: false,
                    hasPadre: false,
                    periodo: true,
                    tipofiltro: filtro['tipo']
                },
                isOperatore
                    ? { persona: user.id }
                    : {}
            );
            // var filter = Object.assign({}, filtro, { tipo: 'R', effettivo: false, tipofiltro: filtro['tipo'] })


            // if (isOperatore) {
            //     const interventiVisibili = currentTasks.filter(intervento => {
            //         const isPadre =
            //             !!intervento?.ripetizione &&
            //             !intervento?.padre;

            //         const managerId =
            //             intervento?.managerObject?.id ??
            //             intervento?.manager;

            //         const assegnatoOperatoreCorrente =
            //             String(managerId) === String(user?.id);

            //         return (
            //             !isPadre &&
            //             assegnatoOperatoreCorrente
            //         );
            //     });

            //     currentTasks.splice(
            //         0,
            //         currentTasks.length,
            //         ...interventiVisibili
            //     );
            // }
            //api.ClassicPost("/anagrafica/turni/current", { data: DateToDateTimeString(new Date()) }).subscribe(turni => {

            //var turno = turni.data?.find(x => true);


            api.ClassicPost('/task/task/open', filter).subscribe(data => {

                var task = [];
                var toRepeat = data.data; //task senza data di fine e data fine compresa nell'intervallo


                function filterOpen(tofilterTask) {
                    // const cliente =
                    //     !filter['clienti']?.length ||
                    //     filter['clienti']?.includes(tofilterTask.cliente);

                    // const responsabili = isOperatore
                    //     ? tofilterTask?.managerObject?.id == user?.id
                    //     : (
                    //         !filter['tecnici']?.length ||
                    //         filter['tecnici']?.includes(tofilterTask?.managerObject?.id)
                    //     );

                    const tipo =
                        !filter['tipofiltro'] ||
                        filter['tipofiltro'] == tofilterTask?.tipoObject?.id;

                    return tipo && !tofilterTask?.padre;



                }



                const toget = toRepeat
                    .filter(filterOpen)
                    .map((p) =>
                        api.ClassicPost('/rma/interventi/get', { id: p.id })
                    );

                if (toget.length === 0) {
                    Concat([]);
                    return;
                }

                forkJoin(toget).subscribe((data: any) => {
                    data.forEach(padre => {
                        const terapia = Object.assign({}, padre.data);
                        var mappedNewTask = Object.assign(
                            {},
                            padre.data,
                            {
                                // turno,
                                type: 'R',
                                padre: terapia.id,
                                note: '',
                                padreObject: terapia,
                            });
                        mappedNewTask.id = undefined;
                        mappedNewTask.data_inizio_effettiva = null;
                        mappedNewTask.data_fine_effettiva = null;
                        mappedNewTask.data_fine_prevista = null;
                        mappedNewTask.data_inizio_prevista = null;
                        console.log('mappedNewTask: ', mappedNewTask);

                        /* var PeriodicRelatedTask = DynamicCrudService.PeriodicRelatedTask(padre, mappedNewTask, filtro.fine, false);
                        console.log('periodic task', PeriodicRelatedTask);
                        task = [...task, ...PeriodicRelatedTask.filter(newTask => !currentTasks.find(x => x.data_inizio_prevista == newTask.data_inizio_prevista || x.data_attivita == newTask.data_attivita))];*/
                        /*   const PeriodicRelatedTask =
                            DynamicCrudService.PeriodicRelatedTask(
                                padre,
                                mappedNewTask,
                                filtro.fine,
                                false
                            );*/
                        // api.ClassicPost('/rma/interventi/get', { id: terapia.id }).subscribe(data => {
                        //     console.log('data', data);
                        //     console.log('dateAssegnate', data?.data?.interventi?.map(x => x.data_inizio_prevista));

                        // });

                        const fineRipetizioniRaw =
                            padre.data.data_fine_prevista ?? filtro.fine;

                        let fineRipetizioni = fineRipetizioniRaw;

                        if (fineRipetizioniRaw) {
                            const dataFine = new Date(fineRipetizioniRaw);

                            // giorno finale intero
                            dataFine.setHours(23, 59, 59, 999);

                            fineRipetizioni = DateToDateTimeString(dataFine);
                            console.log("FIne", dataFine);
                        }

                        const PeriodicRelatedTask =
                            DynamicCrudService.PeriodicRelatedTask(
                                padre.data,
                                mappedNewTask,
                                fineRipetizioni,
                                false
                            );

                        const periodicTaskFiltrati = PeriodicRelatedTask.filter(newTask => {
                            //potrebbe aver causato problemii 
                            /*const dataTask = (
                                newTask.data_inizio_prevista ??
                                newTask.data_attivita
                            )?.substring(0, 16);

                            const dentroIntervallo =
                                (!filtro.inizio || dataTask >= filtro.inizio) &&
                                (!filtro.fine || dataTask <= filtro.fine);*/
                            const dataTask = (
                                newTask.data_inizio_prevista ??
                                newTask.data_attivita
                            )?.substring(0, 10);

                            const isDomenica = (() => {
                                if (!dataTask) {
                                    return false;
                                }
                                const [anno, mese, giorno] = dataTask.split('-').map(Number);
                                const data = new Date(anno, mese - 1, giorno);
                                return data.getDay() === 0;
                            })();

                            const dentroIntervallo =
                                (!filtro.inizio || dataTask >= filtro.inizio.substring(0, 10)) &&
                                (!filtro.fine || dataTask <= filtro.fine.substring(0, 10));

                            const giaPresente = currentTasks.some(x => {
                                const dataCorrente = (
                                    x.data_inizio_prevista ??
                                    x.data_attivita
                                )?.substring(0, 16);

                                return dataCorrente === dataTask;
                            });

                            const giaPresenteFigli = padre.data?.interventi?.some(y => {
                                const dataFiglio = (
                                    y.data_inizio_prevista ??
                                    y.data_attivita
                                )?.substring(0, 10);

                                return (
                                    dataFiglio === dataTask?.substring(0, 10) &&
                                    y.padre == newTask.padre
                                );
                            }) ?? false;

                            const cliente =
                                !filter['clienti']?.length ||
                                filter['clienti']?.includes(newTask.cliente);

                            const responsabili = isOperatore
                                ? newTask?.managerObject?.id == user?.id
                                : (
                                    !filter['tecnici']?.length ||
                                    filter['tecnici']?.includes(newTask?.managerObject?.id)
                                );

                            const chiuso =
                                !filter['chiuso'] ||
                                filter['chiuso'] == newTask?.chiuso;

                            const tipo =
                                !filter['tipofiltro'] ||
                                filter['tipofiltro'] == newTask?.tipoObject?.id;

                            const approvazione =
                                (filter['approvazione'] == undefined &&
                                    filter['approvazione'] == null) ||
                                filter['approvazione'] == newTask?.approvazione ||
                                (!filter['approvazione'] && !newTask?.approvazione);

                            const accessorio =
                                !filter['accessorio'] ||
                                newTask?.accessoriObject?.some(
                                    x => x.id == filter['accessorio']
                                );
                            return dentroIntervallo && !isDomenica && !giaPresente && cliente && responsabili && chiuso && tipo && approvazione && accessorio && !giaPresenteFigli;
                        });

                        task = [...task, ...periodicTaskFiltrati];
                    })
                    Concat(task)
                });



            })
            //   });
        },
        mapList: (x, filtro) => {
            const user = JSON.parse(
                localStorage.getItem('currentUser') || '{}'
            );

            const isOperatore = user?.ruoliObject?.some(
                r => r.id === 'OP'
            );

            let interventi = isOperatore
            ? x.filter(item => {
                const isPadreRicorrente =
                    (
                        item?.ripetizione?.nGiorni != null ||
                        item?.ripetizione?.frequenza === 'PE'
                    ) && !item?.padre;
        
                return !isPadreRicorrente;
            })
            : x;

            if (
                !isOperatore &&
                filtro?.soloPadriRicorrenti === true
            ) {
                interventi = interventi.filter(item =>
                    (
                        item?.ripetizione?.nGiorni != null ||
                        item?.ripetizione?.frequenza === 'PE'
                    ) && !item?.padre
                );
            }
            return interventi;
        },
        TrStyle: (item: any) => {
            const isPadreRicorrente =
                (
                    item?.ripetizione?.nGiorni !== null || item?.ripetizione?.frequenza === 'PE'
                ) && !item?.padre;

            return isPadreRicorrente
                ? {
                    'background-color': '#fff4cc',
                    'border-left': '5px solid #f0ad4e'
                }
                : {};
        },
        type: 'R',
        addButton: true,
        restRoute: '/rma/interventi',
        defaultFilter: (() => {
            const user = JSON.parse(
                localStorage.getItem('currentUser') || '{}'
            );

            const isOperatore = user?.ruoliObject?.some(
                r => r.id === 'OP'
            );

            const oggi = new Date();

            const giornoSettimana = oggi.getDay();

            const distanzaDalLunedi =
                giornoSettimana === 0
                    ? -6
                    : 1 - giornoSettimana;

            const inizio = new Date(oggi);
            inizio.setDate(oggi.getDate() + distanzaDalLunedi);

            const fine = new Date(inizio);
            fine.setDate(inizio.getDate() + 6);

            return {
                tutti: !isOperatore,
                periodo: true,

                inizio: formatDate(inizio),
                fine: formatDate(fine)
            };
        })(),
        /*defaultFilter: (() => {
            const user = JSON.parse(localStorage.getItem('currentUser') || '{}');
        
            const isOperatore =
                user?.ruoliObject?.some(r => r.id === 'OP');
        
            return {
                tutti: !isOperatore
            };
        })(),*/
        OnSaveMap: (x: any, api: ApiPathsService, bup: any, component: DynamicCrudService) => {
            const user = JSON.parse(localStorage.getItem('currentUser') || '{}');

            const userId = user?.id;
            const managerId =
                x.manager ||
                x.managerObject?.id;
            const isOperatore =
                user?.ruoliObject?.some(r => r.id === 'OP');

            const isOperatoreResponsabile =
                isOperatore && userId === managerId;

            console.log("IS OPERATORE", isOperatore);
            console.log("IS RESPONSABILE", isOperatoreResponsabile);

            return {
                ...x,

                data_inizio_effettiva:
                    !x.data_inizio_effettiva &&
                        !bup?.data_inizio_effettiva &&
                        isOperatoreResponsabile
                        ? DateToDateTimeString(new Date())
                        : x.data_inizio_effettiva,

                data_fine_effettiva:
                    x.chiuso === true && !x.data_fine_effettiva
                        ? DateToDateTimeString(new Date())
                        : x.data_fine_effettiva
            };
        },
        Label: '',
        Headers: [
            { nome: "Titolo", oggetti: ["nome"] },
            { nome: "Operatore", oggetti: ['managerObject'], type: "object", field: ['fullName'], hideif: { hasRoles: ['U'] } },
            { nome: "Tipo", oggetti: ['tipoObject'], type: "object", field: ['label'] },
            { nome: "Approvazione", oggetti: [''], inputType: 'text', color: [{ colore: '#ffd000', fieldexist: 'id' }, { colore: '#ff0000', boolFalse: 'approvazione' }, { colore: '#239d00', boolTrue: 'approvazione' }], hideif: { hasRoles: ['U'] } },
            {
                nome: "Chiuso",
                oggetti: ["chiuso"],
                type: "func",
                func: (item: any) => item.chiuso === true ? "✅" : "❌"
            },
            { nome: "Data", oggetti: ['data_inizio_prevista'], inputType: 'datetime-local' },

        ],
        AzioniLista: [
            {
                nome: '', single: true, parameterInArray: true, class: 'link font-16 text-danger font-medium mr-2', filtertype: '69', type: 'POST', restRoute: '/rma/interventi/delete', icon: 'fas fa-trash', preAlert: "Sei sicuro di voler eliminare l'intervento?", successMex: "Intervento Eliminato con successo", parameter: [{ nome: "id", parameter: 'id' }], hideif: {
                    func: (intervento: any) => {
                        const user = JSON.parse(
                            localStorage.getItem("currentUser") || "{}"
                        );

                        const isOperatore = user?.ruoliObject?.some(
                            ruolo => String(ruolo?.id).toUpperCase() === "OP"
                        );

                        return (
                            !isOperatore &&
                            !!intervento?.id &&
                            !intervento.approvazione &&
                            !intervento.chiuso
                        );
                    }
                },
            },
            {
                nome: 'Delega selezionati',
                single: false,
                delegaMultiplaAlima: true,
                close: true,
                icon: 'fas fa-user-edit alima-delega-icon',
                class: 'btn btn-info rounded-pill p-2',
                labelClass: 'text-white',
                type: 'edit',
                successMex: 'Responsabile aggiornato',
                HideButtons: true,

                hideif: {
                    func: (x) => {
                        const user = JSON.parse(
                            localStorage.getItem('currentUser') || '{}'
                        );

                        const isOperatore = user?.ruoliObject?.some(
                            ruolo =>
                                String(ruolo?.id).toUpperCase() === 'OP'
                        );

                        if (!x) {
                            return !isOperatore;
                        }

                        const isInterventoPadre =
                            !!x.ripetizione &&
                            !x.padre;

                        return (
                            !isOperatore &&
                            !isInterventoPadre &&
                            x.chiuso !== true &&
                            !x.data_inizio_effettiva
                        );
                    }
                },

                campi: [
                    {
                        nome: 'Nuovo Responsabile',
                        source: '/anagrafica/persone/list',
                        responseHasData: true,
                        parameter: [
                            { nome: 'page', value: 1 },
                            { nome: 'size', value: 200 },
                            { nome: 'ruolo', value: 'OP' }
                        ],
                        oggetti: ['manager'],
                        internalOutput: 'managerObject',
                        OutputField: 'manager',
                        modificabile: true,
                        required: true,
                        inputType: 'singleDropdown',
                        placeholder: 'Seleziona operatore',
                        settings: {
                            singleSelection: true,
                            closeDropDownOnSelection: true,
                            singleOutput: true,
                            idField: 'id',
                            textField: 'fullName',
                            allowSearchFilter: true,
                            allowRemoteDataSearch: false
                        },
                        class: 'col-lg-12',
                        visibleifProhibited: true
                    },
                    {
                        nome: 'Note Delega',
                        oggetti: ['pressione'],
                        inputType: 'textarea',
                        modificabile: true,
                        class: 'col-lg-12'
                    }
                ]
            }

        ],
        Azioni: [
            {
                nome: 'Delega',
                close: true,
                icon: 'fas fa-user-edit text-primary',
                class: 'btn',
                labelClass: 'text-primary',
                type: 'edit',
                successMex: "Responsabile aggiornato",
                HideButtons: true,
                hideif: {
                    func: (x) => {
                        const user = JSON.parse(
                            localStorage.getItem('currentUser') || '{}'
                        );

                        const isOperatore = user?.ruoliObject?.some(
                            ruolo => String(ruolo?.id).toUpperCase() === 'OP'
                        );

                        const isInterventoPadre =
                            !!x?.ripetizione &&
                            !x?.padre;

                        return (
                            !isOperatore &&
                            !isInterventoPadre &&
                            x.chiuso !== true &&
                            !x.data_inizio_effettiva
                        );
                    }
                },

                campi: [
                    {
                        nome: 'Nuovo Responsabile',
                        source: '/anagrafica/persone/list',
                        responseHasData: true,
                        parameter: [
                            { nome: "page", value: 1 },
                            { nome: "size", value: 200 },
                            { nome: "ruolo", value: 'OP' }
                        ],
                        oggetti: ['manager'],
                        internalOutput: 'managerObject',
                        OutputField: 'manager',
                        modificabile: true,
                        inputType: 'singleDropdown',
                        placeholder: 'Seleziona operatore',
                        settings: {
                            singleSelection: true,
                            closeDropDownOnSelection: true,
                            singleOutput: true,
                            idField: 'id',
                            textField: 'fullName',
                            allowSearchFilter: true,
                            allowRemoteDataSearch: false,
                        },
                        class: 'col-lg-12',
                        visibleifProhibited: true
                    },
                    {
                        nome: 'Note Delega',
                        oggetti: ['pressione'],
                        inputType: 'textarea',
                        modificabile: true,
                        class: 'col-lg-12'
                    }
                ]
            }
        ],
        sezioni: [
            {
                sezione: '',
                campi: [
                    // { nome: 'Codice', oggetti: ['id'], modificabile: false, inputType: 'text', class: 'col-lg-3 mb-2' },
                    {
                        nome: 'Acronimo Beneficiario',
                        oggetti: ['acronimo'],
                        inputType: 'text',
                        modificabile: false,
                        class: 'col-lg-12 mb-2'
                    },
                    {
                        nome: 'Beneficiario',
                        source: '/anagrafica/clienti/list',
                        responseHasData: true,
                        parameter: [{ nome: "page", value: 1 }, { nome: "size", value: 1000 }, { nome: "ruolo", value: 'C' }],
                        oggetti: ['cliente'],
                        internalOutput: 'clienteObject',
                        OutputField: 'cliente',
                        OnChange: 'OnClienteChange',
                        modificabile: true,
                        inputType: 'singleDropdown',
                        disabledif: {
                            hasRoles: ['OP']
                        },
                        placeholder: 'Seleziona un Beneficiario',
                        settings: {
                            singleSelection: true,
                            closeDropDownOnSelection: true,
                            singleOutput: true,
                            idField: 'id',
                            textField: 'statoCivile',
                            searchPlaceholderText: "Cerca",
                            allowSearchFilter: true,
                            allowRemoteDataSearch: false,
                        },
                        class: 'col-lg-12 mb-2',
                        visibleifProhibited: true
                    },
                    {
                        nome: 'Esecutore',
                        source: '/anagrafica/persone/list',
                        responseHasData: true,
                        parameter: [{ nome: "page", value: 1 }, { nome: "size", value: 200 }, { nome: "ruolo", value: 'OP' }],
                        internalOutput: 'managerObject',
                        oggetti: ['manager'],
                        OutputField: 'manager',
                        OnChange: 'OnOperatoreChange',
                        /*OnFilter: 'filtroManager',*/
                        modificabile: true,
                        inputType: 'singleDropdown',
                        disabledif: { hasRoles: ['OP', 'AS', 'PS'] },
                        placeholder: 'Seleziona un Operatore',
                        settings: {
                            singleSelection: true,
                            closeDropDownOnSelection: true,
                            singleOutput: true,
                            idField: 'id',
                            textField: 'fullName',
                            searchPlaceholderText: "Cerca",
                            allowSearchFilter: true,
                            allowRemoteDataSearch: true,
                        },
                        class: 'col-lg-12 mb-2',
                        allowedCapacity: ['assegnazione-attivita'],
                        visibleifProhibited: false
                    },
                    {
                        modificabile: true,
                        nome: 'Tipo Intervento',
                        oggetti: ['tipo'],
                        inputType: 'singleDropdown',
                        source: '/settings/get',
                        parameter: [{ nome: "id", value: "tipo_intervento" }, { nome: "type", value: "tipo_intervento" }],
                        internalOutput: 'tipoObject',
                        OutputField: 'tipo',
                        placeholder: 'Seleziona',
                        settings: {
                            singleSelection: true,
                            closeDropDownOnSelection: true,
                            singleOutput: true,
                            idField: 'id',
                            textField: 'label',
                            allowSearchFilter: true,
                        },
                        titleClass: 'col-form-label',
                        class: 'col-lg-12 mb-2',
                        visibleifProhibited: true
                    },
                    {
                        modificabile: true,
                        nome: 'Status intervento',
                        oggetti: ['chiuso'],
                        inputType: 'singleDropdown',
                        source: [{ id: true, label: 'Chiuso' }, { id: false, label: 'Non Chiuso' }],
                        internalOutput: 'chiusoObject',
                        OutputField: 'chiuso',
                        placeholder: 'Seleziona',
                        settings: {
                            singleSelection: true,
                            closeDropDownOnSelection: true,
                            singleOutput: true,
                            idField: 'id',
                            textField: 'label',
                        },
                        titleClass: 'col-form-label',
                        class: 'col-lg-6 mb-2',
                        visibleifProhibited: true,
                    },
                    {
                        modificabile: true,
                        nome: 'Approvazione',
                        oggetti: ['approvazione'],
                        inputType: 'singleDropdown',
                        source: [{ id: true, label: 'Approvato' }, { id: false, label: 'Non Approvato' }],
                        internalOutput: 'approvazioneObject',
                        OutputField: 'approvazione',
                        placeholder: 'Seleziona',
                        settings: {
                            singleSelection: true,
                            closeDropDownOnSelection: true,
                            singleOutput: true,
                            idField: 'id',
                            textField: 'label',
                        },
                        hideif: { hasRoles: ['OP', 'AS'] },
                        titleClass: 'col-form-label',
                        class: 'col-lg-6 mb-2',
                        visibleifProhibited: true,
                    },
                    { nome: 'Nome Intervento:', oggetti: ['nome'], modificabile: true, inputType: 'text', class: 'col-lg-12 mb-2' },
                    { nome: 'Data Inizio Prevista:', oggetti: ['data_inizio_prevista'], modificabile: true, inputType: 'datetime-local', class: 'col-lg-3 mb-2' },
                    { nome: 'Data Fine Prevista', oggetti: ['data_fine_prevista'], modificabile: true, inputType: 'datetime-local', class: 'col-lg-3 mb-2', hideif: { hasRoles: ['OP'] } },
                    //{ nome: 'Data Fine:', oggetti: ['data_fine_prevista'], hideif: { fieldnotexist: 'data_fine_prevista' }, modificabile: true, inputType: 'datetime-local', class: 'col-lg-3' },
                    //{ nome: 'Data Assegnazione:', oggetti: ['data_assegnazione_tec'], hideif: { fieldnotexist: 'id' }, disabledif: { fieldexist: 'id' }, modificabile: true, inputType: 'datetime-local', class: 'col-lg-3' },
                    { nome: 'Data Inizio Intervento', oggetti: ['data_inizio_effettiva'], hideif: { fieldnotexist: 'id' }, modificabile: true, inputType: 'datetime-local', class: 'col-lg-3 mb-2' },
                    { nome: 'Data Fine Intervento', oggetti: ['data_fine_effettiva'], hideif: { fieldnotexist: 'id' }, modificabile: true, inputType: 'datetime-local', class: 'col-lg-3 mb-2' },
                    { nome: 'Descrizione Intervento:', oggetti: ['note'], inputType: 'textarea', modificabile: true, class: 'col-lg-12 mb-2' },
                    { nome: 'Note Private:', oggetti: ['noteTecnico'], inputType: 'textarea', modificabile: true, class: 'col-lg-12 mb-2' },
                    {
                        modificabile: true,
                        nome: 'Aggiungi Beni',
                        oggetti: ['addAccessori'],
                        inputType: 'singleDropdown',
                        source: '/prodotti/list',
                        parameter: [{ nome: "page", value: 1 }, { nome: "size", value: 200 }, { nome: "tipo", value: 69 }],
                        responseHasData: true,
                        internalOutput: 'addAccessoriObject',
                        OnChange: "AddAccessorioAlima",
                        placeholder: 'Seleziona',
                        settings: {
                            singleSelection: true,
                            closeDropDownOnSelection: true,
                            singleOutput: true,
                            idField: 'id',
                            textField: 'prodotto',
                            allowSearchFilter: true,
                        },
                        titleClass: 'col-form-label',
                        class: 'col-lg-12 mb-2',
                        visibleifProhibited: true
                    },
                    {
                        nome: 'Beni', oggetti: ['accessoriObject'], type: "table", header: [{ nome: "Bene", oggetti: ['prodotto'] }, { nome: "Quantità", oggetti: ['quantita'], type: 'number', modificabile: true }], modificabile: true, class: 'col-lg-12', azioni: [
                            {
                                ExternalOnClick: 'OnDeleteAccessorio',
                                icon: 'fa-trash',
                                tooltip: 'Elimina',
                                color: 'red'
                            }
                        ]
                    },
                    { nome: "Files", type: "Files", url: "/rma/rma/file", class: 'col-lg-12', OnChange: 'OnFilesChange', modificabile: true }

                ]
            },
            {
                sezione: '',
                campi: [
                    // {
                    //   nome: 'Frequenza',
                    //   modificabile: true,
                    //   disabledif: { fieldexist: 'firmatario' },
                    //   oggetti: ['tipo'],
                    //   inputType: 'singleDropdown',
                    //   source: '/rma/interventi/types',
                    //   internalOutput: 'tipoObject',
                    //   OutputField: 'tipo',
                    //   placeholder: 'Seleziona',
                    //   settings: {
                    //     singleSelection: true,
                    //     closeDropDownOnSelection: true,
                    //     singleOutput: true,
                    //     idField: 'id',
                    //     textField: 'label',
                    //     allowSearchFilter: true,
                    //   },
                    //   titleClass: 'control-label col-form-label',
                    //   class: 'col-lg-12',
                    //   visibleifProhibited: true
                    // },
                    {
                        hideif: { hasRoles: ['OP'] },
                        nome: '', Sources: {
                            frequenze: [
                                {
                                    id: 'G',
                                    label: 'Giornaliera',
                                    campi: [
                                        {
                                            nome: 'Frequenza (GG)',
                                            OnChange: 'change',
                                            hideif: { hasRoles: ['OP'] },
                                            disabledif: { fieldexist: 'firmatario' },
                                            modificabile: true,
                                            oggetti: ['ripetizione'],
                                            type: 'object',
                                            field: ['nGiorni'],
                                            internalOutput: 'ripetizione',
                                            inputType: 'singleDropdown',
                                            source: [
                                                { id: 1, label: 1 },
                                                { id: 2, label: 2 },
                                                { id: 3, label: 3 },
                                                { id: 4, label: 4 },
                                                { id: 5, label: 5 },
                                                { id: 6, label: 6 },
                                                { id: 7, label: 7 },
                                                { id: 8, label: 8 },
                                                { id: 9, label: 9 },
                                                { id: 10, label: 10 },
                                                { id: 11, label: 11 },
                                                { id: 12, label: 12 },
                                                { id: 13, label: 13 },
                                                { id: 14, label: 14 },
                                                { id: 15, label: 15 },
                                                { id: 16, label: 16 },
                                                { id: 17, label: 17 },
                                                { id: 18, label: 18 },
                                                { id: 19, label: 19 },
                                                { id: 20, label: 20 },
                                                { id: 21, label: 21 },
                                                { id: 22, label: 22 },
                                                { id: 23, label: 23 },
                                                { id: 24, label: 24 },
                                                { id: 25, label: 25 },
                                                { id: 26, label: 26 },
                                                { id: 27, label: 27 },
                                                { id: 28, label: 28 },
                                                { id: 29, label: 29 },
                                                { id: 30, label: 30 },
                                            ],
                                            class: 'col-lg-4',
                                            settings: {
                                                singleSelection: true,
                                                closeDropDownOnSelection: true,
                                                singleOutput: true,
                                                idField: 'id',
                                                textField: 'label',
                                                allowSearchFilter: true,
                                            },
                                        },
                                        {
                                            nome: 'Orari',
                                            OnChange: 'change',
                                            hideif: { hasRoles: ['OP'] },
                                            disabledif: { fieldexist: 'firmatario' },
                                            modificabile: true,
                                            oggetti: ['orari'],
                                            internalOutput: 'orari',
                                            inputType: 'singleDropdown',
                                            source: [
                                                { ora: '08:00', label: '08:00', cSomministrazioni: 'NP' },
                                                { ora: '08:15', label: '08:15', cSomministrazioni: 'NP' },
                                                { ora: '08:30', label: '08:30', cSomministrazioni: 'NP' },
                                                { ora: '08:45', label: '08:45', cSomministrazioni: 'NP' },
                                                { ora: '09:00', label: '09:00', cSomministrazioni: 'NP' },
                                                { ora: '09:15', label: '09:15', cSomministrazioni: 'NP' },
                                                { ora: '09:30', label: '09:30', cSomministrazioni: 'NP' },
                                                { ora: '09:45', label: '09:45', cSomministrazioni: 'NP' },
                                                { ora: '10:00', label: '10:00', cSomministrazioni: 'NP' },
                                                { ora: '10:15', label: '10:15', cSomministrazioni: 'NP' },
                                                { ora: '10:30', label: '10:30', cSomministrazioni: 'NP' },
                                                { ora: '10:45', label: '10:45', cSomministrazioni: 'NP' },
                                                { ora: '11:00', label: '11:00', cSomministrazioni: 'NP' },
                                                { ora: '11:15', label: '11:15', cSomministrazioni: 'NP' },
                                                { ora: '11:30', label: '11:30', cSomministrazioni: 'NP' },
                                                { ora: '11:45', label: '11:45', cSomministrazioni: 'NP' },
                                                { ora: '12:00', label: '12:00', cSomministrazioni: 'NP' },
                                                { ora: '12:15', label: '12:15', cSomministrazioni: 'NP' },
                                                { ora: '12:30', label: '12:30', cSomministrazioni: 'NP' },
                                                { ora: '12:45', label: '12:45', cSomministrazioni: 'NP' },
                                                { ora: '13:00', label: '13:00', cSomministrazioni: 'NP' },
                                                { ora: '13:15', label: '13:15', cSomministrazioni: 'NP' },
                                                { ora: '13:30', label: '13:30', cSomministrazioni: 'NP' },
                                                { ora: '13:45', label: '13:45', cSomministrazioni: 'NP' },
                                                { ora: '14:00', label: '14:00', cSomministrazioni: 'NP' },
                                                { ora: '14:15', label: '14:15', cSomministrazioni: 'NP' },
                                                { ora: '14:30', label: '14:30', cSomministrazioni: 'NP' },
                                                { ora: '14:45', label: '14:45', cSomministrazioni: 'NP' },
                                                { ora: '15:00', label: '15:00', cSomministrazioni: 'NP' },
                                                { ora: '15:15', label: '15:15', cSomministrazioni: 'NP' },
                                                { ora: '15:30', label: '15:30', cSomministrazioni: 'NP' },
                                                { ora: '15:45', label: '15:45', cSomministrazioni: 'NP' },
                                                { ora: '16:00', label: '16:00', cSomministrazioni: 'NP' },
                                                { ora: '16:15', label: '16:15', cSomministrazioni: 'NP' },
                                                { ora: '16:30', label: '16:30', cSomministrazioni: 'NP' },
                                                { ora: '16:45', label: '16:45', cSomministrazioni: 'NP' },
                                                { ora: '17:00', label: '17:00', cSomministrazioni: 'NP' },
                                                { ora: '17:15', label: '17:15', cSomministrazioni: 'NP' },
                                                { ora: '17:30', label: '17:30', cSomministrazioni: 'NP' },
                                                { ora: '17:45', label: '17:45', cSomministrazioni: 'NP' },
                                                { ora: '18:00', label: '18:00', cSomministrazioni: 'NP' },
                                                { ora: '18:15', label: '18:15', cSomministrazioni: 'NP' },
                                                { ora: '18:30', label: '18:30', cSomministrazioni: 'NP' },
                                                { ora: '18:45', label: '18:45', cSomministrazioni: 'NP' },
                                                { ora: '19:00', label: '19:00', cSomministrazioni: 'NP' },
                                                { ora: '19:15', label: '19:15', cSomministrazioni: 'NP' },
                                                { ora: '19:30', label: '19:30', cSomministrazioni: 'NP' },
                                                { ora: '19:45', label: '19:45', cSomministrazioni: 'NP' },
                                                { ora: '20:00', label: '20:00', cSomministrazioni: 'NP' },
                                            ],
                                            class: 'col-lg-4',
                                            settings: {
                                                singleSelection: false,
                                                closeDropDownOnSelection: true,
                                                singleOutput: false,
                                                idField: 'ora',
                                                textField: 'label',
                                                allowSearchFilter: true,
                                            },
                                        },
                                        // {
                                        //     nome: "Condizione Somministrazione",
                                        //     source: [{ id: 'PP', label: 'Prima dei pasti' }, { id: 'DP', label: 'Dopo dei pasti' }, { id: 'SV', label: 'Stomaco Vuoto' }, { id: 'LP', label: 'Lontano dai Pasti' }, { id: 'NP', label: 'Nessuna Prescrizione' }],
                                        //     oggetti: ['ripetizione'],
                                        //     internalOutput: 'ripetizione',
                                        //     OutputField: 'cSomministrazioni',
                                        //     OnChange: 'cSomministrazionichange',
                                        //     modificabile: true,
                                        //     type: 'object',
                                        //     field: ['cSomministrazioniobject'],
                                        //     inputType: 'singleDropdown',
                                        //     placeholder: "Seleziona una condizione di somministrazione",
                                        //     settings: {
                                        //         singleSelection: true,
                                        //         closeDropDownOnSelection: true,
                                        //         singleOutput: true,
                                        //         idField: 'id',
                                        //         textField: 'label',
                                        //         searchPlaceholderText: "Cerca",
                                        //         allowSearchFilter: true,
                                        //         allowRemoteDataSearch: false,
                                        //     },
                                        //     class: 'col-lg-4',
                                        //     visibleifProhibited: true
                                        // },
                                    ],
                                    ChangeType: (item, ripetizione) => {
                                        ripetizione.endCondition = 'never';
                                        ripetizione.frequency = 'days';
                                        ripetizione.repeatEvery = ripetizione.nGiorni?.id;
                                        ripetizione.daysOfWeek = undefined;
                                    }
                                },
                                // {
                                //     id: 'S',
                                //     label: 'Settimanale',
                                //     campi: [
                                //         { nome: 'Ogni x Settimane', OnChange: 'change', disabledif: { fieldexist: 'firmatario' }, inputType: 'number', modificabile: true, oggetti: ['ripetizione'], type: 'object', field: ['nGiorni'], class: 'col-lg-6' },
                                //         { nome: '', disabledif: { fieldexist: 'firmatario' }, inputType: 'day-selection', modificabile: true, oggetti: ['ripetizione.daysOfWeek'], class: 'col-lg-6', style: { "align-content": "center" } },
                                //     ],
                                //     ChangeType: (item, ripetizione) => {
                                //         console.log("Settimanale change")
                                //         ripetizione.daysOfWeek = ripetizione.daysOfWeek ?? {
                                //             monday: true,
                                //             tuesday: false,
                                //             wednesday: false,
                                //             thursday: false,
                                //             friday: false,
                                //             saturday: false,
                                //             sunday: false,
                                //         };
                                //         ripetizione.endCondition = 'never';
                                //         ripetizione.frequency = 'weeks';
                                //         ripetizione.repeatEvery = ripetizione.nGiorni;
                                //     }
                                // },
                                {
                                    id: 'PE',
                                    label: 'personalizzata',
                                    campi: [
                                        {
                                            nome: 'Orari',
                                            OnChange: 'change',
                                            hideif: { hasRoles: ['OP'] },
                                            disabledif: { fieldexist: 'firmatario'},
                                            modificabile: true,
                                            oggetti: ['orari'],
                                            internalOutput: 'orari',
                                            inputType: 'singleDropdown',
                                            source: [
                                                { ora: '08:00', label: '08:00', cSomministrazioni: 'NP' },
                                                { ora: '08:15', label: '08:15', cSomministrazioni: 'NP' },
                                                { ora: '08:30', label: '08:30', cSomministrazioni: 'NP' },
                                                { ora: '08:45', label: '08:45', cSomministrazioni: 'NP' },
                                                { ora: '09:00', label: '09:00', cSomministrazioni: 'NP' },
                                                { ora: '09:15', label: '09:15', cSomministrazioni: 'NP' },
                                                { ora: '09:30', label: '09:30', cSomministrazioni: 'NP' },
                                                { ora: '09:45', label: '09:45', cSomministrazioni: 'NP' },
                                                { ora: '10:00', label: '10:00', cSomministrazioni: 'NP' },
                                                { ora: '10:15', label: '10:15', cSomministrazioni: 'NP' },
                                                { ora: '10:30', label: '10:30', cSomministrazioni: 'NP' },
                                                { ora: '10:45', label: '10:45', cSomministrazioni: 'NP' },
                                                { ora: '11:00', label: '11:00', cSomministrazioni: 'NP' },
                                                { ora: '11:15', label: '11:15', cSomministrazioni: 'NP' },
                                                { ora: '11:30', label: '11:30', cSomministrazioni: 'NP' },
                                                { ora: '11:45', label: '11:45', cSomministrazioni: 'NP' },
                                                { ora: '12:00', label: '12:00', cSomministrazioni: 'NP' },
                                                { ora: '12:15', label: '12:15', cSomministrazioni: 'NP' },
                                                { ora: '12:30', label: '12:30', cSomministrazioni: 'NP' },
                                                { ora: '12:45', label: '12:45', cSomministrazioni: 'NP' },
                                                { ora: '13:00', label: '13:00', cSomministrazioni: 'NP' },
                                                { ora: '13:15', label: '13:15', cSomministrazioni: 'NP' },
                                                { ora: '13:30', label: '13:30', cSomministrazioni: 'NP' },
                                                { ora: '13:45', label: '13:45', cSomministrazioni: 'NP' },
                                                { ora: '14:00', label: '14:00', cSomministrazioni: 'NP' },
                                                { ora: '14:15', label: '14:15', cSomministrazioni: 'NP' },
                                                { ora: '14:30', label: '14:30', cSomministrazioni: 'NP' },
                                                { ora: '14:45', label: '14:45', cSomministrazioni: 'NP' },
                                                { ora: '15:00', label: '15:00', cSomministrazioni: 'NP' },
                                                { ora: '15:15', label: '15:15', cSomministrazioni: 'NP' },
                                                { ora: '15:30', label: '15:30', cSomministrazioni: 'NP' },
                                                { ora: '15:45', label: '15:45', cSomministrazioni: 'NP' },
                                                { ora: '16:00', label: '16:00', cSomministrazioni: 'NP' },
                                                { ora: '16:15', label: '16:15', cSomministrazioni: 'NP' },
                                                { ora: '16:30', label: '16:30', cSomministrazioni: 'NP' },
                                                { ora: '16:45', label: '16:45', cSomministrazioni: 'NP' },
                                                { ora: '17:00', label: '17:00', cSomministrazioni: 'NP' },
                                                { ora: '17:15', label: '17:15', cSomministrazioni: 'NP' },
                                                { ora: '17:30', label: '17:30', cSomministrazioni: 'NP' },
                                                { ora: '17:45', label: '17:45', cSomministrazioni: 'NP' },
                                                { ora: '18:00', label: '18:00', cSomministrazioni: 'NP' },
                                                { ora: '18:15', label: '18:15', cSomministrazioni: 'NP' },
                                                { ora: '18:30', label: '18:30', cSomministrazioni: 'NP' },
                                                { ora: '18:45', label: '18:45', cSomministrazioni: 'NP' },
                                                { ora: '19:00', label: '19:00', cSomministrazioni: 'NP' },
                                                { ora: '19:15', label: '19:15', cSomministrazioni: 'NP' },
                                                { ora: '19:30', label: '19:30', cSomministrazioni: 'NP' },
                                                { ora: '19:45', label: '19:45', cSomministrazioni: 'NP' },
                                                { ora: '20:00', label: '20:00', cSomministrazioni: 'NP' },
                                            ],
                                        class: 'col-lg-4',
                                        settings: {
                                            singleSelection: false,
                                            closeDropdDownOnSelection: true,
                                            singleOutput: false,
                                            idField: 'ora',
                                            textField: 'label',
                                            allowSearchFilter: true
                                        }                                        
                                    }
                                    ]
                                }
                            ]
                        },
                        disabledif: { fieldexist: 'firmatario' },
                        inputType: 'ripetizioneTask',
                        modificabile: true,
                        oggetti: ['ripetizione'],
                        class: 'col-lg-12'
                    },
                   
                    // {
                    //     nome: 'Orari',
                    //     oggetti: ['orari'],
                    //     modificabile: true,
                    //     type: 'table',
                    //     header: [
                    //         { nome: "Orario", oggetti: ['ora'], modificabile: true, inputType: 'time', class: 'col-lg-12' },
                    //         {
                    //             nome: "Condizione Somministrazione",
                    //             source: [{ id: 'PP', label: 'Prima dei pasti' }, { id: 'DP', label: 'Dopo dei pasti' }, { id: 'SV', label: 'Stomaco Vuoto' }, { id: 'LP', label: 'Lontano dai Pasti' }, { id: 'NP', label: 'Nessuna Prescrizione' }],
                    //             oggetti: ['cSomministrazioni'],
                    //             internalOutput: 'cSomministrazioniObject',
                    //             OutputField: 'cSomministrazioni',
                    //             OnChange: 'cSomministrazionichange',
                    //             modificabile: true,
                    //             inputType: 'singleDropdown',
                    //             placeholder: "Seleziona una condizione di somministrazione",
                    //             settings: {
                    //                 singleSelection: true,
                    //                 closeDropDownOnSelection: true,
                    //                 singleOutput: true,
                    //                 idField: 'id',
                    //                 textField: 'label',
                    //                 searchPlaceholderText: "Cerca",
                    //                 allowSearchFilter: true,
                    //                 allowRemoteDataSearch: false,
                    //             },
                    //             class: 'col-lg-12',
                    //             visibleifProhibited: true
                    //         },

                    //     ],
                    //     azioni: [{
                    //         ExternalOnClick: 'OnDeleteCondizione',
                    //         icon: 'fa-trash',
                    //         tooltip: 'Elimina',
                    //         color: 'red'
                    //     }],
                    //     class: 'col-lg-12'
                    // },

                ]
            },
        ],


    }
    return task;
}